import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    debounceTime: { type: Number, default: 300 },
    throttleTime: { type: Number, default: 1000 }
  }

  connect() {
    this.lastThrottleTime = 0
  }

  submit() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    const currentValue = this.element.value
    
    if (currentValue.length === 0) {
      const form = this.element.closest('form')
      if (form) {
        form.requestSubmit()
      }
      return
    }

    const throttleRemaining = this.throttleTimeValue - (Date.now() - this.lastThrottleTime)
    const delay = Math.max(this.debounceTimeValue, throttleRemaining)

    this.debounceTimeout = setTimeout(() => {
      const form = this.element.closest('form')
      if (form) {
        this.lastThrottleTime = Date.now()
        form.requestSubmit()
      }
    }, delay)
  }
} 
